<template>
  <div class="hot-news">
      <div class="hot-news-title">热门资源</div>
      <div class="hot-news-list">
        <div class="hot-new-item" v-for="(item, index) in list" :key="index" @click="onDetail(item)">
          <el-image class="hot-new-item-image" :src="item.image_show"></el-image>
          <div class="hot-new-item-box">
            <div class="hot-new-item-title">{{item.title}}</div>
            <div class="hot-new-item-foot">
              <span class="price">¥{{ item.price_min }} - ¥{{ item.price_max }}</span>
              <span class="time">{{ formatStr2Date(item.update_time) }}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
</template>
<script>
import { getAssetsList } from '@/api/assets'
import {formatDate} from '@/utils/util'
export default {
  name: 'ProductHot',
  props: {
    product: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },
  data() {
    return {
      list: [],
      pageQuery: {
        page: 1,
        pagesize: 4,
        sort: 'click'
      }
    }
  },
  created() {
    this.getList()
  },
  methods: {
    onDetail(item) {
      this.$router.push({name: 'detail', query: {id: item.id}})
    },
    formatStr2Date(str) {
      return formatDate(str)
    },
    getList() {
			getAssetsList(this.pageQuery).then((res) => {
				if (res.code === 200 && res.data) {
					this.list = res.data.list
				}
			})
		},
  }
}
</script>
<style lang="scss" scoped>
.hot-news {
  width: 280px;
  .hot-news-title {
    height: 35px;
    font-size: 18px;
    line-height: 25px;
    font-weight: 700;
    padding-left: 6px;
  }
  .hot-news-list {
    background: #fff;
    border: 1px solid #e5e5e5;
    padding: 0 10px;
    border-radius: 5px;
    .hot-new-item {
      display: flex;
      flex-direction: row;
      padding: 14px 0;
      border-bottom: 1px solid #eaeaea;
      cursor: pointer;
      .hot-new-item-image {
        width: 40px;
        height: 40px;
      }
      .hot-new-item-box {
        flex: 1;
        margin-left: 10px;
        .hot-new-item-title {
          font-size: 16px;
          height: 23px;
          overflow: hidden;
        }
        .hot-new-item-foot {
          font-size: 13px;
          display: flex;
          flex-direction: row;
          justify-content: space-between;
          .price {
            color: #e23435;
            font-weight: bold;
          }
          .time {
            color: #999;
          }
        }
      }
    }
    .hot-new-item:last-child {
      border-bottom: 0;
    }
  }
}
</style>